import React from 'react';

import {
  Session,
  useCreateSessionLink,
  useIsAdmin,
  useSessionLinks,
} from '@app/api';
import { Button, PriceEdition } from 'components';

import { EditSessionLayout } from './components/EditSessionLayout';
import { SessionFormSection } from './components/SessionFormSection';
import { SessionSubmitLine } from './components/SessionSubmitLine';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { SessionLinkListItem } from './admin/SessionLinkListItem';
import { Navigate } from 'react-router-dom';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    padding: [[theme.marginBase * 4, theme.marginBase * 5]],
    height: '100%',
    maxWidth: theme.maxContentWidth.hugeBlock,
  },
  sessionLinksContainer: {
    marginTop: theme.marginBase * 3,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 2,
  },
  defaultPrices: {
    marginTop: theme.marginBase * 2,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.marginBase * 2,
  },
}));

interface Props {
  session: Session;
}

export const EditSessionAdmin = ({ session }: Props) => {
  const classes = useStyles();

  const isAdmin = useIsAdmin();

  const { mutate: createSessionLink } = useCreateSessionLink(session.id);
  const { data: sessionLinks } = useSessionLinks(session.id);

  if (!isAdmin) {
    return <Navigate to=".." />;
  }

  return (
    <EditSessionLayout
      session={session}
      contentClassName={classes.container}
      footer={<SessionSubmitLine session={session} noSubmit />}
    >
      <SessionFormSection title="Prix par défaut">
        <div className={classes.defaultPrices}>
          <PriceEdition session={session} />
        </div>
      </SessionFormSection>

      <SessionFormSection title="Liens de l'étude">
        <div className={classes.sessionLinksContainer}>
          {sessionLinks?.map((sessionLink) => (
            <SessionLinkListItem
              sessionLink={sessionLink}
              key={sessionLink.id}
              session={session}
            />
          ))}
        </div>
        <div className={classes.buttons}>
          <Button
            small
            color="green"
            type="button"
            text="Ajouter"
            onClick={createSessionLink}
          />
        </div>
      </SessionFormSection>
    </EditSessionLayout>
  );
};
